import React from "react";
import {
    Navigate,
} from "react-router-dom";

const ControlSponsorListComponent = React.lazy(() => import("../../../../../components/control-sponsors/components/list/page"));
const ControlSponsorAddComponent = React.lazy(() => import("../../../../../components/control-sponsors/components/add/page"));
const ControlSponsorReportListComponent = React.lazy(() => import("../../../../../components/control-sponsor-reports/components/list/page"));
const ControlSponsorReportDetailComponent = React.lazy(() => import("../../../../../components/control-sponsor-reports/components/detail/page"));

export const sponsorsRoutes = [
    {
        path: 'list',
        element: <ControlSponsorListComponent />
    },
    {
        path: 'add',
        element: <ControlSponsorAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/control/sponsors/add" />
    },
    {
        path: 'edit/:id',
        element: <ControlSponsorAddComponent />
    },
    {
        path: 'report',
        element: <ControlSponsorReportListComponent />
    },
    {
        path: 'show/:id',
        element: <ControlSponsorReportDetailComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/control/sponsors/list" />
    },
];